import { CloseCircle, DocumentText1, Clock } from "iconsax-react";
import CheckIcon from "@/shared/assets/icons/CheckIcon";
import type { BadgeColor } from "@/shared/ui";
import type { ContractorProfile } from "../types";

type ContractorStatus = ContractorProfile["status"];

export const CONTRACTOR_STATUS_MAP: Record<
  ContractorStatus,
  { label: string; color: BadgeColor; icon: React.ReactNode }
> = {
  draft: {
    label: "overview.contractorStatus.draft",
    color: "info",
    icon: <DocumentText1 size={14} color="currentColor" />,
  },
  pending_signing: {
    label: "overview.contractorStatus.pending_signing",
    color: "notice",
    icon: <Clock size={14} color="currentColor" variant="Bold" />,
  },
  signed: {
    label: "overview.contractorStatus.signed",
    color: "positive",
    icon: <CheckIcon />,
  },
  revoked: {
    label: "overview.contractorStatus.revoked",
    color: "negative",
    icon: <CloseCircle size={14} color="currentColor" variant="Bold" />,
  },
  termination_pending: {
    label: "overview.contractorStatus.termination_pending",
    color: "notice",
    icon: <Clock size={14} color="currentColor" variant="Bold" />,
  },
  terminated: {
    label: "overview.contractorStatus.terminated",
    color: "gray",
    icon: <CloseCircle size={14} color="currentColor" variant="Bold" />,
  },
};
